export class Pallet {
    id: string;
    name: string;
    location_id: number;
    location_name: string;
    location_branch_id: number;
    location_branch_name: string;
    location_branch_code: string;
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/pallets/pallet.ts